/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnDestroy } from '@angular/core';
import { RestError } from '../../models/api.io';

@Component({
    selector: 'lib-crm-alert',
    templateUrl: 'crm-alert.component.html',
    styleUrls: ['crm-alert.component.scss'],
})

export class CrmAlertComponent implements OnDestroy {
    message: RestError;

    constructor() {

    }

    ngOnDestroy(): void {

    }

    hide(): void {
      this.message = null;
    }

    show(message: RestError): void {
      this.message = message;
    }

    showError(text: string): void {
      this.message = new RestError();
      this.message.txt = text;
      this.message.code = 500;
    }

    showSuccess(text: string): void {
      this.message = new RestError();
      this.message.txt = text;
      this.message.code = 200;
    }
}
